import { CasesComponent } from './pages/cases/cases.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { PrincipalComponent } from './principal.component';

import { HomeComponent } from './pages/home/home.component';

import { RevendaComponent } from './pages/revenda/revenda.component';
import { ContatoComponent } from './pages/contato/contato.component';
import { SegmentosComponent } from './pages/segmentos/segmentos.component';
import { SegmentoEducacaoComponent } from './pages/segmentos/pages/segmento-educacao/segmento-educacao.component';
import { SegmentoFinanceiroComponent } from './pages/segmentos/pages/segmento-financeiro/segmento-financeiro.component';
import { SegmentoMercadoGraficoComponent } from './pages/segmentos/pages/segmento-mercado-grafico/segmento-mercado-grafico.component';
import { SegmentoSaudeComponent } from './pages/segmentos/pages/segmento-saude/segmento-saude.component';
import { SegmentoSegurosComponent } from './pages/segmentos/pages/segmento-seguros/segmento-seguros.component';
import { SegmentoSetorPublicoComponent } from './pages/segmentos/pages/segmento-setor-publico/segmento-setor-publico.component';
import { SegmentoVarejoComponent } from './pages/segmentos/pages/segmento-varejo/segmento-varejo.component';
import { CaseFinanceiroComponent } from './pages/cases/pages/case-financeiro/case-financeiro.component';
import { CaseGeneraliComponent } from './pages/cases/pages/case-generali/case-generali.component';
import { CaseMercadoGraficoComponent } from './pages/cases/pages/case-mercado-grafico/case-mercado-grafico.component';
import { CaseSaoCristovaoComponent } from './pages/cases/pages/case-sao-cristovao/case-sao-cristovao.component';
import { CaseSegurosComponent } from './pages/cases/pages/case-seguros/case-seguros.component';
import { PlataformaCanaisDeContatoComponent } from './pages/plataforma/pages/plataforma-canais-de-contato/plataforma-canais-de-contato.component';
import { PlataformaAssinaturaEletronicaComponent } from './pages/plataforma/pages/plataforma-assinatura-eletronica/plataforma-assinatura-eletronica.component';
import { PlataformaChatbotsComponent } from './pages/plataforma/pages/plataforma-chatbots/plataforma-chatbots.component';
import { PlataformaDashboardsComponent } from './pages/plataforma/pages/plataforma-dashboards/plataforma-dashboards.component';
import { PlataformaFormulariosDinamicosComponent } from './pages/plataforma/pages/plataforma-formularios-dinamicos/plataforma-formularios-dinamicos.component';
import { PlataformaJornadasDigitaisComponent } from './pages/plataforma/pages/plataforma-jornadas-digitais/plataforma-jornadas-digitais.component';
import { PlataformaComponent } from './pages/plataforma/plataforma.component';

export const principalRoutes: Routes = [
  {
    path: '',
    component: PrincipalComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      
      {
        path: 'home',
        component: HomeComponent
      },
      
      {
        path: 'segmentos',
        component: SegmentosComponent,
        children: [
          {
            path: '',
            redirectTo: 'financeiro',
            pathMatch: 'full'
          },
          
          {
            path: 'financeiro',
            component: SegmentoFinanceiroComponent
          },
          {
            path: 'saude',
            component: SegmentoSaudeComponent
          },
          {
            path: 'seguros',
            component: SegmentoSegurosComponent
          },
          {
            path: 'varejo',
            component: SegmentoVarejoComponent
          },
          {
            path: 'setor-publico',
            component: SegmentoSetorPublicoComponent
          },
          {
            path: 'educacao',
            component: SegmentoEducacaoComponent
          },
          {
            path: 'mercado-grafico',
            component: SegmentoMercadoGraficoComponent
          }
        ]
      }, 

      {
        path: 'cases', 
        component: CasesComponent,
        children: [
          {
            path: '',
            redirectTo: 'financeiro',
            pathMatch: 'full'
          },
          
          {
            path: 'financeiro',
            component: CaseFinanceiroComponent      
          },
          {
            path: 'sao-cristovao',
            component: CaseSaoCristovaoComponent      
          },
          {
            path: 'generali',
            component: CaseGeneraliComponent      
          },
          {
            path: 'mercado-grafico',
            component: CaseMercadoGraficoComponent      
          },
          {
            path: 'seguros',
            component: CaseSegurosComponent      
          }
    
        ]
      },

      {
        path: 'plataforma', 
        component: PlataformaComponent,
        children: [
          {
            path: '',
            redirectTo: 'jornadas-digitais',
            pathMatch: 'full'
          },
          {
            path: 'jornadas-digitais',
            component: PlataformaJornadasDigitaisComponent
          },
          {
            path: 'assinatura-eletronica',
            component: PlataformaAssinaturaEletronicaComponent
          },
          {
            path: 'dashboards',
            component: PlataformaDashboardsComponent
          },
          {
            path: 'chatbots',
            component: PlataformaChatbotsComponent
          },
          {
            path: 'canais-de-contato',
            component: PlataformaCanaisDeContatoComponent
          },
          {
            path: 'formularios-dinamicos',
            component: PlataformaFormulariosDinamicosComponent
          }
        ]
      },
      
      {
        path: 'revenda',
        component: RevendaComponent
      },
      {
        path: 'contato',
        component: ContatoComponent
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(principalRoutes),
    LocalizeRouterModule.forChild(principalRoutes)
  ],
  exports: [
    RouterModule,
    LocalizeRouterModule
  ]
})

export class PrincipalRoutingModule { }
